import React from 'react';
import {
  LayoutDashboard, Users, Link2, ClipboardCheck, CalendarDays, Settings, CreditCard, CircleHelp,
  CircleUser, LogOut, House, Briefcase, TreePalm, Building2, Banknote, Scale, FileText,
  MessagesSquare, ClipboardList, Lightbulb, BarChart3, Lock,
} from 'lucide-react';

// Nazwy z czasów FontAwesome → cienkie ikony Lucide (menu boczne, etap 2)
const ICONS = {
  'fa-dashboard': LayoutDashboard,
  'fa-users': Users,
  'fa-link': Link2,
  'fa-clipboard-check': ClipboardCheck,
  'fa-calendar-days': CalendarDays,
  'fa-cog': Settings,
  'fa-line-chart': CreditCard,
  'fa-circle-question': CircleHelp,
  'fa-circle-user': CircleUser,
  'fa-right-from-bracket': LogOut,
  'fa-house': House,
  'fa-user-tie': Briefcase,
  'fa-briefcase': Briefcase,
  'fa-umbrella-beach': TreePalm,
  'fa-building': Building2,
  'fa-money-bill-wave': Banknote,
  'fa-scale-balanced': Scale,
  'fa-file-signature': FileText,
  'fa-file-invoice': FileText,
  'fa-comments': MessagesSquare,
  'fa-clipboard-list': ClipboardList,
  'fa-lightbulb': Lightbulb,
  'fa-chart-bar': BarChart3,
};

export function SidebarIcon({ name, dimmed = false }) {
  const Icon = ICONS[name] || LayoutDashboard;
  return <Icon size={18} strokeWidth={1.75} aria-hidden="true" style={{ opacity: dimmed ? 0.5 : 1, flexShrink: 0 }} />;
}

export function LockIcon() {
  return <Lock size={12} strokeWidth={2} aria-label="Dostępne w płatnej wersji" />;
}
